<template>
  <div class="operating_data">
    <div class="enterprise_management">
      <div class="title"> 企业人气值
        <span class="desc">您的用户粉丝越多,人气值越多</span>
      </div>
      <div class="overview-container">
        <div class="chart_left">
          <div class="tab-bar">
            <div class="tab_box">
              <div :class="['tab-item',{'active-tab-item':activeIndex==1}]" @click="activeTab(1)">
                <span class="my_icon"><i class="iconfont">&#xe6cb;</i></span>人气值
              </div>
              <div :class="['tab-item',{'active-tab-item':activeIndex==2}]" @click="activeTab(2)">
                <span class="my_icon"><i class="iconfont">&#xe6cc;</i></span>
                趋势图
              </div>
            </div>
            <p class="tab-bar_right" v-if="activeIndex==1"> 以下涨跌均为近7日数据</p>
          </div>
          <template v-if="activeIndex==1">
            <div class="user-info">
              <div class="img_box">
                <img :src="icon" alt="">
              </div>
              <div class="score_box">
                <div><span class="score">564</span>分</div>
                <div>行业排名:<span style="font-weight: 600;">154</span>/271,820您已超过<span style="font-weight: 600;">99.94</span>%的企业主</div>
              </div>
            </div>
            <div class="progress-wrapper">
              <div class="user_progress">
                <img :src="icon" alt="">
                <span class="score">564</span>
              </div>
              <div class="progress">
                <span class="score">0<span style="font-size: 12px;">分</span></span>
                <div class="dise">
                  <div class="score_dise" style="width: 380px;"></div>
                  <img class="image" style="left: 340.95px;" src="../../../assets/img/company/img1.png" alt="">
                  <img class="image" style="left: 403.342px;" src="../../../assets/img/company/img2.png" alt="">
                  <img class="image" style="left: 443.66px;" src="../../../assets/img/company/img3.png" alt="">
                  <img class="image" style="left: 506.042px;" src="../../../assets/img/company/img4.png" alt="">
                </div>
                <span class="score">1000<span style="font-size: 12px;">分</span></span>
              </div>
            </div>
            <div class="rank_info">
              <div class="rank_info_title">经营榜单</div>
              <div class="rank_info_item_wrap">
                <div class="rank_info_item" v-for="item in rankData" :key="item.name">

                  <div class="img_box">
                    <img :src="item.url" alt="">
                  </div>
                  <div class="score_box">
                    <div><span class="score">{{ item.value }}</span>分</div>
                    <div class="name">{{ item.name }}</div>
                  </div>

                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="change_button_box">
              <div class="box_left">
                <span :class="['tab-item',{'active-tab-item':activeDayIndex==1}]" @click="changeDay(1)">7日趋势</span>
                <span :class="['tab-item',{'active-tab-item':activeDayIndex==2}]" @click="changeDay(2)">30日趋势</span>
              </div>
              <div class="box_right">
                <div class="legend_item"><span class="item" style="background: #2a55e5;"></span>我的经营值</div>
                <div class="legend_item"><span class="item" style="background: #09b160;"></span>行业头部平均值</div>
              </div>
            </div>
            <div class="lineEcharts" ref="lineEchartsRef"></div>
          </template>

        </div>
        <div class="chart_right">
          <p class="title">经营诊断</p>
          <div class="info"> “企业经营值”代表您的生意经营的量化结果（与<b data-v-3e781853="">粉丝增长、线索获取、商品售卖等设置的经营目标</b>相关），可持续发布短视频或开播，有助于企业经营值的提升。 </div>
          <div class="bottom-tool flex-box" data-v-3e781853="">
            <div class="m-row flex-box" data-v-3e781853=""><img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAASySURBVHgB7Z3PaxNREMcn4tVUz/5KLopasRVF8GJFBT0IrQUjXtSDXquIN3/EHyf1oFc9GA+CHqSCgoKi7UFBFNpCSxEPTVs9W+sfUGeSt2G72c1u0uzO2/b7gdfX7OYHzHdn5r3Ne5kMtYGFhYW13PVy6+K22fRrTVsulE0b4zbCbTiTyZRpiWSoRYzRB7j1mLYSGeX2gJYgRtMCuAx/kZbXFb5UStxuNitEUwKw8W8QDB9GkUW4GfXJkQRgw+e4G6RqbAfhlLkdjOINq8KewMY/Q9WkA+NHJ8dthG3XG/bEhgKYkFMihJxWEJsNGhsGEhiCzAuLBNpBYF7wFcC4ziCBdnKWRXjqPVgngEm4EvMRdtrLHLdub2L2E2CKqkkEtJ9RFqDbfWBREjZxP0cgLrrYxkX3gZoHmNAzRSBuJBTl2ROkX+QBRQJJILn1ovOg4gG4+hOn5gWOB/QQSJKaFzgCDBBImgPyJ4Pwo8o68YAeAlr0igC4y6lHlwiwi4AWOREgR0CLXZKEFwhoMQcBlAn9ShLEy2qyjPn5fzQz84v+zs9Tu9nZuZ2y2TVkE9YIIIa/d/8hPX/xsvJ/XBQKJ+jK5QHauHE92YAVOWB29jf19Z+u9Ekgxv/44Y0V3mBFDpArPynjC/JZd/kzbUDdAyTWb9m6m5KmI5ul79+G1b1APQdMjE/WHbtw/iwdO3qE2snbd+/p0eNS7bEIL8m+s3MbaWLdKEg4ysbfv39f4PlxFs07SpIrOsyYbgGEOEZazWKlAI24dv1OnSEdzrPn3Ll1ldJEqiZiExOTgcYXHvO5cZ+QZjOYCSuTKgF27NhWSdBByDntpNosqcsBtznGF07282x5cQLNRkjCNpI6AYQ0GjoI5ABlIIAyEEAZCKAMBFAGAigDAZSBAMpAAGUggDIQQBkIoAwEUAYCKAMBlIEAykAAZSCAMhBAGQigDARQJlWrIvzWhHrpSNnylNQI0GhNqJc0rRFNRQgKWxPqJU1rRJEDlEmFAGFrQr2kaY1oanJA0JpQL2lbI6ouQEdHtu6YbCdqFRklff7yte74uyW8Z5xYsUlvz94Dse4NDuLnjxH1TXrqOUDG7acK/ZQ0smHbhn3CVmzUFi84dPh4ohu1B18+434DaWPFKEi8QAxSOHmC4kSueBkhffzw2grjC9b9XI2McuKYRMnoaNOm9ZXeJvB7QcpgJqyMCDBHQA0IoEtZBBgloEVFgGkCWozBA3QZyZjakH8IaJBfZUppDBFIGinoU3bmAcMEkkbK4NZKmEgYkhoCqB2WHPmaB5gwZMfPCK4MSk5BN3cZK3hBcuQdAWr3guAFibGo6rZfKUPUDo6PMhs/7z7gdze0j3B/KA7Epge9B+sEMO5xiUC7OedX4tz3+wB+Yom7yIXpQSgS91/5ncg0epWp/NmwJDcIRYxfDDrZUADBVNd+QhieNovE/EsmmgQSKoBgqu19IlRciorcYe7zi/leIn0nLG9khk/IC42Rq15CTncU4wuRPMCN8YYitzMEHJxJ7AOnUHNUmhbAwQjRQ9VKrCt14jZE1TvJTRveoWUB3LjEECGkNGKOlle+mDNNYvu06V+1anQ3/wHyJYa06e1nwAAAAABJRU5ErkJggg=="
                class="icon" data-v-3e781853=""><span class="link" data-v-3e781853="">发布短视频</span></div>
            <div class="m-row flex-box" data-v-3e781853=""><img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAYjSURBVHgB7Z3PTxtHFMefo15r0nNKao4NVAEpbaX0AIlSKYdWgiDFSD2EHEhPxUT86CGEOIFeCpEIl7ZBKu6hFUQCIvXQSK1aOBSpKRJEheYYJyTnAPkDyHyXWWu9jL1rrz0zwe8jDWuvbQ7vu+/HvFl7YlQB9vb2jopDuxjNYrwnj0flOCxk5XgkxpoYy7FYLEsRiVGZSKOnxGiToxZZF2OSIohRsgAew/fR4brCo5IR42apQpQkgDD+DWLDB5EWItwM++ZQAgjDJ8RhkfZjOxNMVowzYbzhSNAbhPEv0X7SYeOHJyHGmrBde9AbiwogQ06GOOSUA2y2KG1YkIIhSH4wTUwlKJgXlAJI11kkppJ0CxF+8p88IIBMuIj5HHYqy7YYLf7ErBLgCe0nEabyrAsBWrwn8pKwjPsJYqpFs7Bx2nsi5wEy9DwhptogFDUIT8AxzwPSxOgAubXPfeJ4AF/92sl5gesBbcToJOcFrgApYnTTij8xDj9GeQce0EaMKdohAHc5zdEMAU4SY4oEBEgQY4qTSMJ7xJhimwUwTOCSJFNdWADDsACGYQEMwwIY5i3SzO7uK3r27Dnt7O6Sbj45/THZhlYB7k7P0PjElCOCCerrj1Ey2UmD/b1kC9rmARO3pxzj28DorWG60tNNNqBNgFMftdLW1guygbp4nFb/XaZ4/G0yjZYkvLLyjzXGB8g/yEM2oD0Ju4zeukZNjSdIBxubj+n6yFjeOVURsLHx2Dk2Nb1PujAmQKMw/mlLqhIUBV+lhujBg9+d5z0iP4yJPKGDmp8H4Ko/e+6znPHB9HQm5w3VxpgHhAFX5n8b/zuPP2g6UfGkibL4+sg3ytd0zVOsFGB2bp7m7i04ydsLYjPCQ9fFTorKyI0xbVd5MawSAFf8sEiWc0IAFTBYKvW1cxwaSEXyCBuMD6zKAeMTdwoa3wti9PDIKB0GrBEAYeeuMGxY5uYWaPZesFhhaGzUV3b6sUYAlfFRpmZmvqPF+Z8pefHCgdchQlTQltBVcqqwIgeg4tjczI/JyeQFmpr8NvccYmw9f5GXmPEYeSMoF9TVxQ+cQ2Mu8+P3TmL3J3udWOEBm4qEmFRUOqoGmlumFgMhxvvZ8+c/pT//+FXrjLcQ1s4DdhV1OJpo5YJQ44pqg+FdrPCARoVBVDlhVlEhYYIWFhjeJuMDKwTAle3vCyEu9/YN0d/i+JtoE3R0fuFMzrwgtNjQUo6CNSGoS1Q5/mSIKqdYpfPllW5607GmDMVSYbKEFgOSarICLQnTWDUTHh29FmqpEIYfHLBnXTcKVlVByAWoVppEbP9BJGH/3AB5okvMD8q98k0suARhZRnqhCMxUIp6jRaPUIZiRcytrDDJG+xPOZMx01i9HhBXVEflAE/ylrVI7Ej4i/O/GBehJlbEdnYOTupwkwDu1Bi/bfZWGas9QAcTE1O0YnBtmu8NJeJmXC1TswLYcktMzQow0N9rxU26NR2CBsRsevXhkrIUjdL6LgVjVZB/lltNNjYLL9rU17/rLHnizm2324p2iK7Zspa7o2Hss+c+J5tYEEb3f2HDRKtCiwBY8z31YauxL2b4QchZfbhMNqAlByCeDlnUvbSpja0tB/T0XBYtgVfOvTymviuA1bPBgZQ1344BRn6qwMTME42948ePReqoVgP+rQjDcCvCMCyAYVgAw7AAhmEBDAMBtokxBgtgliwEWCfGFI4AT4kxxSP2ALOsxeTekC+JMUHDEbmVxhIxusGGPll3HmDH6kRtgW1wc1uYIAxhDwHeO0wfDTkPkGHoDjG6yLgbunm3sWIv0EeDK0CuF8ReoI28XbdVWxny3sHVIyuM3+A9oeqGdhD3h6oBbHrGf/KAANI9rhJTaS6rtjhXrgeIN2bEIfTG9EwgiPv3VS/Ein1K7vxZdEtuJhAYP13oxaICALm79gxxeVoqiPlXZTQpSKAAQO629xfxjkthQYe5QxXz/YRaE8Y/kuUT54Xi4KpHyGkJY3wQygO8SG9Ii3GJGBd3EjvpbtQclpIFcJFCtNH+Tqy1OnFbov1OcsmGdylbAC8eMSAEtkZM0OHKF9tyILY/lcf75Rrdy2vlRCSGQJ2qtAAAAABJRU5ErkJggg=="
                class="icon" data-v-3e781853=""><span class="link" data-v-3e781853="">开启直播</span></div>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>
      
    <script>
export default {
  name: "OperatingData",
  data() {
    return {
      activeIndex: 1,
      icon: localStorage.getItem("sIcon"),
      rankData: [
        {
          name: "本周行业黑马",
          url: require("../../../assets/img/company/img1.png"),
          value: 532,
          tip: "本行业最近7天内经营值变动率提升最大的企业主",
        },
        {
          name: "本周大盘黑马",
          url: require("../../../assets/img/company/img2.png"),
          value: 596,
          tip: "企业号大盘最近7天内经营值变动率提升最大的企业主",
        },
        {
          name: "女装行业第一",
          url: require("../../../assets/img/company/img3.png"),
          value: 656,
          tip: "",
        },
        {
          name: "企业号大盘第一",
          url: require("../../../assets/img/company/img4.png"),
          value: 741,
          tip: "",
        },
      ],
      activeDayIndex: 1,
    };
  },
  components: {},
  created() {
    this.icon =
      localStorage.getItem("sIcon") ||
      require("../../../assets/img/image/user_img.png");
  },
  computed: {},

  methods: {
    activeTab(id) {
      this.activeIndex = id;
      if (id == 2) {
        this.$nextTick(() => {
          this.getLineEcharts();
        });
      }else{
              let chart = this.$echarts.init(this.$refs.lineEchartsRef);
              if(chart){
                this.$echarts.dispose(chart)
              }
            }
    },
    changeDay(id) {
      this.activeDayIndex = id;
    },
    getLineEcharts() {
      const today = new Date();
      // 生成近七日的日期数组，按从小到大排列
      const dates = [];
      for (let i = 6; i >= 0; i--) {
        const date = new Date(today);
        date.setDate(today.getDate() - i);
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        dates.push(`${month}-${day}`);
        let chart = this.$echarts.init(this.$refs.lineEchartsRef);
        var xData = dates;
        var y1Data = [563, 562, 564, 565, 564, 564, 0];
        var y2Data = [724, 724, 724, 724, 725, 724, 0];
        let option = {
          tooltip: {
            trigger: "axis",
            backgroundColor: "#ffffff", // 设置提示框背景颜色为白色
            textStyle: {
              color: "#666", // 设置提示框文字颜色为黑色，以保证在白色背景下可见
            },
          },
        //   legend: {
        //     show: true, // 显示图例
        //     icon: "circle", // 设置图例图标为小圆圈
        //     itemWidth: 8, // 设置图例图标宽度，调小图标大小
        //     itemHeight: 8, // 设置图例图标高度，调小图标大小
        //     textStyle: {
        //       color: "#333", // 图例文字颜色
        //       fontSize: 12, // 调小图例文字字体大小
        //     },
        //     bottom: 10,
        //     left: "center",
        //   },
          grid: {
            top: 20,
            left: 30,
            right: 10,
          },
          xAxis: {
            type: "category",
            data: xData,
            axisTick: {
              show: false, // 不显示 x 轴刻度线
            },
            axisLabel: {
              color: "#b3b3b7", // x 轴字体颜色
            },
            axisLine: {
              show: true, // 不显示 x 轴轴线
              lineStyle: {
                color: "#b3b3b7",
              },
            },
          },
          yAxis: [
            {
              axisLine: {
                show: false,
              },
              splitLine: {
                show: true, // 隐藏 y 轴的分隔线
                lineStyle: {
                  color: "#F2F2F4", // 设置轴线颜色为红色
                  type: "dashed", // 设置轴线为虚线
                },
              },
              axisTick: {
                show: false,
              },
              axisLabel: {
                show: true,
                color: "#75767c",
                formatter: function (value) {
                  return value;
                },
              },
            },
            {
              type: "value",
              show: false, // 不显示 y 轴
            },
          ],
          series: [
            {
              name: "我的经营值",
              type: "line",
              data: y1Data,
              smooth:true,
              color: "#2a55e5", 
              yAxisIndex: 0, // 使用第一个 Y 轴
              itemStyle: {
                color: "#2a55e5", // 折线颜色
                normal: {
                        opacity: 0
                    }
              },
              lineStyle: {
                color: "#2a55e5", // 折线颜色
              },
            },
            {
              name: "行业头部平均值",
              type: "line",
              smooth:true,
              data: y2Data,
              color: "#09b160",
              yAxisIndex: 1, // 使用第二个 Y 轴
              itemStyle: {
                color: "#09b160", // 折线颜色
                normal: {
                        opacity: 0
                    }
              },
              lineStyle: {
                color: "#09b160", // 折线颜色
              },
            },
          ],
        };
        chart.setOption(option);
        window.onresize = () => {
          // 基础数据
          chart.resize();
        };
      }
    },
  },
};
</script>
      
      <style lang="scss" scoped>
.operating_data {
  width: 100%;
  padding: 16px 24px;
  box-sizing: border-box;
  .enterprise_management {
    width: 100%;
    background-color: #fff;
    border-radius: 12px;
    // height: 200px;
    padding: 24px;
    box-sizing: border-box;
    .title {
      margin-bottom: 24px;
      font-size: 20px;
      color: #161823;
      .desc {
        margin-left: 8px;
        font-size: 14px;
        color: #16182380;
      }
    }
    .overview-container {
      display: flex;
      align-items: stretch;
      justify-content: space-between;
      background: #16182305;
      border-radius: 8px;
      .chart_left {
        flex: 4 4 864px;
        padding: 24px;
        box-sizing: border-box;
        .tab-bar {
          width: 100%;
          margin-bottom: 32px;
          height: 19px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .tab_box {
            display: flex;
            justify-content: center;
            align-items: center;
            .tab-item {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 88px;
              height: 32px;
              border-radius: 4px;
              color: #161823;
              cursor: pointer;
              .my_icon {
                margin-right: 6px;
                font-size: 16px;
                .icon {
                  width: 1em;
                  height: 1em;
                  fill: currentColor;
                  overflow: hidden;
                  vertical-align: -0.15em;
                  font-size: 16px;
                  color: #161823;
                }
              }
            }
            .active-tab-item {
              color: #fff;
              background: #2a55e5;
            }
          }
        }
        .tab-bar_right {
          margin-left: auto;
          text-align: left;
          padding: 0 !important;
        }
        .user-info {
          display: flex;
          align-items: center;
          margin-bottom: 12px;
          .img_box {
            width: 62px;
            height: 62px;
            border-radius: 100%;
            margin-right: 5px;
            img {
              width: 100%;
              height: 100%;
              border-radius: 100%;
            }
          }
          .score_box {
            .score {
              line-height: 38px;
              font-weight: 700;
              font-size: 38px;
              color: #161823;
              vertical-align: middle;
            }
          }
        }
        .progress-wrapper {
          .user_progress {
            img {
              margin-left: 385px;
              margin-right: 4px;
              width: 24px;
              height: 24px;
              border-radius: 50%;
            }
            .score {
              font-weight: 600;
            }
          }
          .progress {
            display: flex;
            align-items: center;
            margin-top: 10px;
            .score {
              flex-grow: 0;
              flex-shrink: 0;
              height: 28px;
              line-height: 36px;
              color: #16182480;
              font-size: 18px;
              margin-right: 3px;
              font-size: 32px;
              vertical-align: bottom;
              font-weight: 600;
              display: inline-block;
            }

            .dise {
              position: relative;
              flex-grow: 0;
              flex-shrink: 0;
              width: 678px;
              height: 28px;
              background-color: #1618230d;
              border-radius: 24px;
              .score_dise {
                position: absolute;
                height: 28px;
                background-color: #2a55e5;
                border-radius: 24px;
                top: 0;
                left: 0;
              }
              .image {
                width: 24px;
                height: 24px;
                position: absolute;
                top: 1px;
                left: 0;
              }
            }
          }
        }
        .rank_info {
          display: flex;
          margin-top: 24px;
          align-items: center;
          .rank_info_title {
            margin-right: 15px;
            padding-left: 8px;
            box-sizing: border-box;
            width: 36px;
            height: 74px;
            writing-mode: vertical-lr;
            text-align: center;
            letter-spacing: 2px;
            font-weight: 700;
            font-size: 12px;
            background: #1618230d;
            border-radius: 8px;
          }
          .rank_info_item_wrap {
            display: flex;
            .rank_info_item {
              display: flex;
              align-items: flex-start;
              margin-right: 12px;
              padding: 12px;
              width: 162px;
              height: 74px;
              background: #1618230d;
              border-radius: 8px;
              overflow: hidden;
              box-sizing: border-box;
              .img_box {
                width: 24px;
                height: 24px;
                border-radius: 100%;
                margin-right: 5px;
                img {
                  width: 100%;
                  height: 100%;
                  border-radius: 100%;
                }
              }
              .score_box {
                .score {
                  font-weight: 700;
                  font-size: 24px;
                  color: #161823;
                  vertical-align: middle;
                }
                .name {
                  line-height: 17px;
                  font-size: 12px;
                  color: #161823cc;
                }
              }
            }
          }
        }
        .change_button_box {
          display: flex;
          align-content: center;
          justify-content: space-between;
          .box_left {
            .tab-item {
              display: inline-block;
              margin-right: 8px;
              width: 74px;
              height: 36px;
              line-height: 36px;
              text-align: center;
              background: #f3f3ff33;
              border-radius: 4px;
              color: #16182380;
              cursor: pointer;
            }
            .active-tab-item {
              font-weight: 700;
              background: #2a55e50a;
              color: #2a55e5;
            }
          }
          .box_right {
            display: flex;
            align-items: center;
            .legend_item {
              font-size: 12px;
              color: #161823;
              display: flex;
              align-items: center;
              margin-right: 8px;
              .item {
                margin-right: 5px;
                width: 12px;
                height: 12px;
                border-radius: 1px;
                display: inline-block;
              }
            }
          }
        }
        .lineEcharts {
          width: 100%;
          height: 250px;
        }
      }
      .chart_right {
        flex: 1 1 280px;
        display: flex;
        flex-direction: column;
        padding: 24px;
        background-color: #f5f6fa;
        .title {
          padding: 0 !important;
          line-height: 22px;
          font-size: 16px;
          color: #161823;
        }
        .info {
          padding: 0;
          //   margin-top: 10px;
          //   line-height: 22px;
          color: #16182380;
        }
        .bottom-tool {
          display: flex;
          align-items: center;
          margin-top: auto;
          .m-row {
            display: flex;
            align-items: center;
            margin-right: 10px;
            .icon {
              margin-right: 8px;
              width: 32px;
              height: 32px;
            }
            .link {
              margin-right: 12px;
              line-height: 22px;
              text-decoration: underline;
              color: #161823;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
</style>
      